export default "__VITE_ASSET__x4_FBzn6__"